// src/components/dashboard/widgets/pending-actions-panel.tsx
import { ChevronRight } from 'lucide-react';
import type { PendingAction } from '@/src/lib/types';

export default function PendingActionsPanel({ pendingActions, onOpen }: { pendingActions: PendingAction[]; onOpen?: () => void }) {
  return (
    <div className="rounded-2xl border border-cream-line bg-warm-gray p-5 h-full">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm font-semibold text-cream">
          Pending actions
          {pendingActions.length > 0 && (
            <span className="bg-amber-500/20 text-amber-400 text-[10px] font-bold px-1.5 py-0.5 rounded-full">
              {pendingActions.length}
            </span>
          )}
        </div>
        {onOpen && pendingActions.length > 0 && (
          <button onClick={onOpen} className="text-xs text-amber-400 hover:text-amber-300 transition-colors">Review</button>
        )}
      </div>
      {pendingActions.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 gap-2 text-cream-muted/50">
          <div className="w-8 h-8 rounded-full bg-leaf-500/10 flex items-center justify-center">
            <span className="text-leaf-text text-sm">✓</span>
          </div>
          <p className="text-xs">Nothing to approve — you're all caught up.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {pendingActions.slice(0, 4).map((action) => (
            <div key={action.id} onClick={onOpen} role={onOpen ? 'button' : undefined} className={`flex items-center gap-3 py-2 border-b border-cream-line/50 last:border-0 ${onOpen ? 'cursor-pointer hover:bg-white/5 rounded-md' : ''}`}>
              <div className="w-4 h-4 rounded-full border border-cream-line flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-cream truncate">{action.type}</p>
                <p className="text-[11px] text-cream-muted">{action.reason}</p>
              </div>
              <ChevronRight size={13} className="text-cream-muted/40 flex-shrink-0" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}